import { PaxCount, ReservationExtent } from '@mews-commander/data-access';

export const RESOURCE_CATEGORY_ID = 'resourceCategoryId';
export const FIELD_ARRAY_AVAILABILITY = 'fieldArrayAvailability';
export const AVAILABILITIES = 'availabilities';
export const FORM_NAME = 'availabilityBlokForm';
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const START_HOUR = 'startHour';
export const END_HOUR = 'endHour';
export const ADJUSTMENT_VALUE = 'adjustmentValue';
export const VALUE = 'value';
export const PERSON_COUNT = 'personCount';
export const PAX_COUNT = 'paxCount';

export const CELL_HEIGHT = 74;
export const TOTAL_CELL_HEIGHT = 53;
export const CELL_WIDTH = 136;

export const NO_DECIMAL_PLACES = { precision: 0 };

export const MAX_DAY_COUNT = 31;

export const RESERVATION_EXTENT: ReservationExtent = {
    reservationGroups: true,
    availabilityBlocks: false,
    companionships: false,
    accounts: false,
    orderItems: false,
    products: false,
    businessSegments: false,
    generalNotes: false,
    channelManagerNotes: false,
    vouchers: false,
    partnerCompanies: false,
    rates: false,
    specialRequestNotes: false,
    travelAgencies: false,
    origin: true,
    bookingEngines: false,
    purchaseOrderNumbers: false,
};

export const DEFAULT_PAX_COUNT: PaxCount = {
    personCount: 1,
    unitCount: 0,
};
